//libs
import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from "moment";
//components
import HistoryTable from './HistoryTable';
//config,helpers orther
import {isAdmin} from '../../../helpers';

class SearchResultsTable extends Component {


    editWheelSet(e){
        if (typeof(this.props.editWheelSet)==="function"){
            this.props.editWheelSet(e);
        }
        e.preventDefault();
    }

    render() {

        const {loading, title, data} = this.props;

        let isHistory = false;
        if (data.length>0 && typeof(data[0].wheelHistory)!=="undefined" && data[0].wheelHistory!==null && data[0].wheelHistory.length>0 && data[0].wheelHistory[0]!==null){
            isHistory=true;
        }

        const columns = [
            {
                Header: "Regnr",
                accessor: "regNo"
            },
            {
                Header: "Serienr",
                accessor: "waggonNo",
            },
            {
                Header: "Bilmodell",
                accessor: "carModel",
            },
            {
                Header: "Hjulmodell",
                accessor: "wheeltype.name",
            },
            {
                Header: "Off rent date",
                accessor: "offRentDateTime",
                Cell: props => moment(props.value).format('YYYY-MM-DD - HH:mm')
            },
            {
                Header: "Last on rent",
                accessor: "lastOnRentDate",
                Cell: props => moment(props.value).format('YYYY-MM-DD')
            }
        ];

        if (isAdmin()){
            columns.push({
                Header: "",
                accessor:'id',
                width:50,
                Cell: props => (
                    <a className="action icon edit"
                       onClick={(e) => this.editWheelSet(e)}
                       value={props.value} href={"#redigera-wheel"} title={"Redigera"}>
                    </a>
                )

            })
        }

        return (

            <div>
                <h2>{title}</h2>
                <ReactTable
                    data={data}
                    loading={loading}
                    loadingText="Laddar..."
                    minRows="0"
                    pageSize="200"
                    className="search-wheelset-table"
                    showPagination={false}
                    noDataText="Inga hjul hittades"
                    columns={columns}
                />

                {this.props.children}


                {isHistory &&
                    <div className={"HistoryTable"}>
                        <HistoryTable
                            title={"Historik ("+data[0].regNo+" "+data[0].wheeltype.name+")"}
                            loading={loading}
                            data={data[0].wheelHistory}
                            />
                    </div>
                }


            </div>
        );
    }
}


export default SearchResultsTable;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Search/SearchResultsTable.js